module.exports = "mutation readAdviceRequest($adviceRequestId:String!,$read:Boolean!){readAdviceRequest(adviceRequestId:$adviceRequestId,read:$read)}"